import _defaults from 'lodash/defaults';

class Department {
    public PK: number;
    public Name: string;

    public constructor(department?: Partial<Department>) {
        _defaults(this, department);    
    }
}

export {Department};
